import {Directive, ElementRef, Inject, Injector, OnDestroy, Optional, SkipSelf} from '@angular/core';

import {
  IWidgetConfig,
  StylableComponent,
  provideAsWidgetRef,
  styler,
  register
} from "@wm/components-base";
import {CarouselDirective} from "../carousel.directive";
import {get} from "lodash-es";

const DEFAULT_CLS = 'item carousel-item app-carousel-item';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-carousel-template',
  hostClass: DEFAULT_CLS
};

let parentEl: any;

@Directive({
  selector: '[wmCarouselTemplate]',
  standalone: true,
  providers: [
    provideAsWidgetRef(CarouselTemplateDirective)
  ],
  exportAs: 'wmCarouselTemplate'
})
export class CarouselTemplateDirective extends StylableComponent implements OnDestroy {
  static initializeProps = register('wm-carousel-template');

  constructor(inj: Injector,
              @SkipSelf() @Optional() private _viewParent: CarouselDirective,
              @SkipSelf() @Inject(ElementRef) public _el: any) {
    super(inj, WIDGET_CONFIG, _viewParent);
    styler(this.nativeElement, this);

  }

  private getParentScope(): CarouselDirective {
    return this._viewParent || this._el.nativeElement.widget || get($(this.nativeElement).closest('[widgettype="wm-carousel"]')[0], 'widget');
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();
    this.getParentScope().register(this);
  }

  override ngOnDestroy() {
    this.getParentScope().unregister(this);
    super.ngOnDestroy();
  }

}

